import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormSubscription, GlobalFormsState } from './types';

const defaultState = (): GlobalFormsState => ({
  createVisit: [],
  editVisit: [],
  createMeeting: [],
  createEvent: [],
  editPatient: [],
  createPatient: [],
  createUser: [],
  editUser: [],
  createRole: [],
  editRole: [],
  createSubtenant: [],
  editSubtenant: [],
  importFromMiniscreen: [],
  createDoctor: [],
  editDoctor: [],
  createDataBlockType: [],
  createDataBlockField: [],
  editDataBlockField: [],
  editDataBlock: [],
  createDataBlock: [],
  appointmentColorSettings: [],
  hl7Filter: [],
  createResource: [],
  editResource: [],
  changeOwnPassword: [],
  changeLanguage: [],
  setPassword: [],
  importDocument: [],
  importMeasurementFiles: [],
  importGDTFile: [],
  mergeField: [],
  createDictionaryRecord: [],
  editDictionaryRecord: [],
  configureCustomDictionary: [],
  createCustomDictionaryItem: [],
  editCustomDictionaryItem: [],
  createCalendarConfiguration: [],
  editCalendarConfiguration: [],
  createPatientListConfiguration: [],
  editPatientListConfiguration: [],
  mergePair: [],
  manageGDTMappings: [],
  sendViaGDT: [],
  selectVisits: [],
  createAbsence: [],
  editAbsence: [],
  createNote: [],
  editNote: [],
  fileVersionHistory: [],
  editDataBlockStatistic: [],
  createDataBlockStatistic: [],
  createVisitType: [],
  editVisitType: [],
  editInputTemplates: [],
  reimportMeasurements: [],
  mergePatientWithCardData: [],
  mergeInsuranceCardData: [],
  copyDataBlockFieldValue: [],
  createCodePrefix: [],
  sendTestMessage: [],
});

export const globalFormsSlice = createSlice({
  name: 'globalForms',
  initialState: defaultState(),
  reducers: {
    addSubscription: (
      state,
      action: PayloadAction<FormSubscription>,
    ): GlobalFormsState => {
      const newSubscription = action.payload;
      const subscriptionsForForm = state[newSubscription.formType];
      state[newSubscription.formType] = [
        ...subscriptionsForForm.filter(
          (subscription) => subscription.id !== newSubscription.id,
        ),
        newSubscription,
      ];
      return state;
    },
    removeSubscription: (
      state,
      action: PayloadAction<FormSubscription>,
    ): GlobalFormsState => {
      const subscriptionToDelete = action.payload;
      const subscriptionsForForm = state[subscriptionToDelete.formType];
      state[subscriptionToDelete.formType] = [
        ...subscriptionsForForm.filter(
          (subscription) => subscription.id !== subscriptionToDelete.id,
        ),
      ];
      return state;
    },
  },
});

export const GlobalFormsActions = globalFormsSlice.actions;
